module.exports = __webpack_public_path__ + "img/icon-1.1be4ee88.svg";